<div class="iad-page-403-blocked-agent">
  <img src="assets/403.gif" alt="page 403" title="page 403" />
  <h1>{{ 'iadPage403BlockedAgent.title' | translate }}</h1>
  <p>{{ 'iadPage403BlockedAgent.catchPhrase' | translate }}</p>
  <button mat-raised-button color="primary" routerLink="/agent/home">{{ 'iadPage403BlockedAgent.homeBtnLabel' | translate }}</button>
</div>
